import React from 'react';
import TimeUnitsBar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/time-units-bar/view.tsx';
import type { Props } from './types.tsx';

export const TimelineHeader = ({ fiscalMonth }: Props) => (
	<TimeUnitsBar fiscalMonth={fiscalMonth} />
);
